export default "__VITE_ASSET__56ddbbaf__"